import React from "react";
import { TooltipIcon } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { EFFORT_TO_ESTIMATE } from "../../../constants";
import styles from "./effortTooltip.module.scss";
const EffortTooltip = ({ estimateInDays, effort, violationCount, }) => {
    return (React.createElement(TooltipIcon, { fitContent: true, title: React.createElement(React.Fragment, null,
            "Estimate based on ReversingLabs experience with remediating the reported issue:",
            effort && violationCount ? (React.createElement("div", { className: styles.formula },
                React.createElement("div", { className: styles.fraction },
                    React.createElement("div", { className: styles.quotient },
                        capitalizeFirstLetter(effort),
                        " effort (",
                        EFFORT_TO_ESTIMATE[effort],
                        "h) * number of violations (",
                        violationCount,
                        ")"),
                    "Working day (8h)"),
                "= ",
                estimateInDays,
                " working day",
                estimateInDays !== 1 ? "s" : "")) : (React.createElement("div", { className: styles.formula },
                React.createElement("div", { className: styles.fraction },
                    React.createElement("div", { className: styles.quotient }, "Effort (High/Medium/Low) * number of violations"),
                    "Working day (8h)")))) }));
};
export default EffortTooltip;
//# sourceMappingURL=EffortTooltip.js.map